import TxMccsLogo from '@/assets/TxMCCS_logo_swoosh_final.png'
import { ProfileMenu } from '@/components/Pages/ProfileMenu'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { useAuth } from '@/hooks/useAuth'
import { Link } from 'react-router'

interface HeaderProps {
  hideSidebar?: boolean
}

const Header = ({ hideSidebar }: HeaderProps) => {
  const { isAuthenticated } = useAuth()

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white shadow">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <div className="container mx-auto flex items-center justify-between px-2 md:px-4">
        <div className="flex items-center gap-2">
          {isAuthenticated && !hideSidebar && <SidebarTrigger className="" />}
          <Link
            to="/"
            className="justify-center rounded-md bg-white md:order-[-1]"
          >
            <img
              src={TxMccsLogo}
              alt="TxMCCS Logo"
              className="h-15 object-scale-down p-3 sm:h-20"
            />
          </Link>
        </div>
        <ProfileMenu />
      </div>
    </header>
  )
}

export default Header
